
import React, { useState, useRef, useEffect } from 'react';
import { TSearchData } from '../../screen/Simulation/Simulation';

export type TOptionType =
{
    label: string;
    value: string;
}

type SearchableDropdownProps = {
  options: TOptionType[];
  defaultOption: TSearchData;
  onSelect: (item: TSearchData) => void;
  onChangeInput: (targetValue: string ) => void;
  onFocusInput: () => void;
};

const BASE_CLASS = "searchableDropdown"

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({ options, defaultOption, onSelect, onChangeInput, onFocusInput }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const filteredOptions = options.filter(option => {  
    const concatValues = `${option.value.toLowerCase()} ${option.label.toLowerCase()}`;
    return concatValues.includes(searchTerm.toLowerCase());
  });

  const handleSelect = (option: TSearchData) => {
    onSelect(option);
    setSearchTerm(option.destinyName);
    setIsOpen(false);
  };

  // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   if (!isOpen) return;

  //   if (e.key === 'ArrowDown') {
  //     e.preventDefault();
  //     setHighlightedIndex(prev => (prev + 1) % filteredOptions.length);
  //   } else if (e.key === 'ArrowUp') {
  //     e.preventDefault();
  //     setHighlightedIndex(prev => (prev - 1 + filteredOptions.length) % filteredOptions.length);
  //   } else if (e.key === 'Enter') {
  //     e.preventDefault();
  //     handleSelect({
  //       ...defaultOption,
  //       destinyIsin: filteredOptions[highlightedIndex].value,
  //       destinyName: filteredOptions[highlightedIndex].label,
  //       destinyWeight: defaultOption.originalWeight
  //     });
  //   } else if (e.key === 'Escape') {
  //     setIsOpen(false);
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '300px' }}>
      <input className={`${BASE_CLASS}__input`}
        placeholder={defaultOption.destinyName !== '' ? defaultOption.destinyName :  defaultOption.originalName}
        defaultValue={defaultOption.destinyIsin !== '' ? defaultOption.destinyIsin : defaultOption.originalIsin}
        type="text"
        value={searchTerm}
        onChange={e => {
          setSearchTerm(e.target.value);
          setIsOpen(true);
          setHighlightedIndex(0);
          onChangeInput(e.target.value)
        }}
        // onKeyDown={handleKeyDown}
        onFocus={() => {
          setIsOpen(true);
          onFocusInput();
          }
        }
      />
      {isOpen && filteredOptions.length > 0 && (
        <ul className={`${BASE_CLASS}__modal`}
        >
          {filteredOptions.map((option, index) => (
            <li className={
              `${BASE_CLASS}__box
              ${index === highlightedIndex ? "__highlighted" : ''}
              `}
              key={option.value}
              onClick={() => handleSelect({
                ...defaultOption,
                destinyIsin: option.value,
                destinyName: option.label,
              })}
              onMouseEnter={() => setHighlightedIndex(index)}
            >
              {option.label || option.value}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchableDropdown;
